import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-none-login-header',
  templateUrl: './none-login-header.component.html',
  styleUrls: ['./none-login-header.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class NoneLoginHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
